module.exports = __webpack_public_path__ + "static/media/img_top_main1@3x.ee752d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_top_main1@3x.jpg
// module id = 770
// module chunks = 0